import { useEffect } from "react";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useIntercom } from "react-use-intercom";
import { Routes } from "./Routes";
import { DRAWER_WIDTH, Sidebar } from "./components/Sidebar";
import { Box, Container } from "@mui/material";
import { NotAuthorized } from "./pages/not-authorized/NotAuthorized";

function App() {
  const { boot } = useIntercom();
  const { login, isAuthenticated, isLoading, error, getPermission } =
    useKindeAuth();

  useEffect(() => {
    if (isAuthenticated || isLoading) return;
    login &&
      login({
        app_state: {
          redirectTo: window.location.pathname,
        },
      });
  }, [isAuthenticated, login, isLoading]);

  useEffect(() => {
    // TODO: what if any user data to send here
    boot();
  }, [boot]);

  if (isLoading || !isAuthenticated) return <p>Loading...</p>;

  if (error) return <p>{error}</p>;

  const isAuthorized = getPermission("employer_access").isGranted;

  if (!isAuthorized) return <NotAuthorized />;

  return (
    <>
      <Sidebar />
      <Box
        component={"main"}
        sx={{
          width: `calc(100% - ${DRAWER_WIDTH}px)`,
          flexGrow: 1,
          p: { xs: 2, sm: 3 },
          overflowX: "auto",
          marginLeft: `${DRAWER_WIDTH - 24}px`,
        }}
      >
        <Container
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
          }}
          maxWidth="lg"
        >
          <Routes />
        </Container>
      </Box>
    </>
  );
}

export default App;

// rgb(250, 250, 251)
